import { user as authUser } from "@client/stores/authStore";
import TokenService from "./tokenService";

/**
 * Deep merge of two objects
 * @param obj1
 * @param obj2
 * @returns
 */
export function merge(obj1: any, obj2: any) {
    let key: any
    for (key of Object.keys(obj2)) {
        if (!obj1.hasOwnProperty(key) || typeof obj2[key] !== 'object') obj1[key] = obj2[key];
        else merge(obj1[key] || {}, obj2[key] || {});
    }
    return obj1;
}

/**
 * global date formatter
 */

const userLocale = navigator.language.split('-')[0] || 'de' // z. B. 'en', 'fr', 'de

// create formatter  (e.g. without time)
const dateFormatter = new Intl.DateTimeFormat(userLocale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
})

export const formatDate = (date: string) => {
    return dateFormatter.format(new Date(date))
}

type DataType = 'user' | 'subscription'

/**
 * Update session and auth data of logged in user
 * @param data
 * @param type
 * @returns
 */
export function updateLoggedInUser(data: any, type: DataType = 'user') {
    if (!type || !data) return

    let user
    if (type == 'user') {
        user = data
    } else if (type == 'subscription') {
        let subscription = data
        delete subscription.user
        user = authUser.value
        user.subscription = subscription
    } else {
        return
    }

    // store it in session
    TokenService.updateLocalUser(user)

    // store it also in auth for autoload
    authUser.value = user
}